<template>
	<div v-parallax-fit="parallax" class="slide-note">
		<img src="/themes/rise-theme/dist/images/estate/character-view/henry/04_letter_05.png">
	</div>
</template>

<script>
	export default {
		data() {
			return {
				parallax: [
					{
						start: 4500,
						end: 5500,
						fromStyle: { transform: 'translateX(45%) translateY(-550%)' },
           				toStyle: { transform: 'translateX(45%) translateY(100%)' },
						easing: 'linear'
					},
					{
						start: 8000,
						end: 9000,
						fromStyle: { transform: 'translateX(45%) translateY(100%)' },
           				toStyle: { transform: 'translateX(45%) translateY(550%)' },
						easing: 'linear'
					}
				]
			}
		}
	}
</script>
